import React from 'react';

const INVESTOR_STAGES  = ['Prospect','Contacted','Intro Call','Deep Dive','Due Diligence','Term Sheet','Closed','Passed','On Hold'];
const PARTNER_STAGES   = ['Prospect','Contacted','Intro Call','Evaluating','Pilot','Active Partner','Churned','On Hold'];
const STATUSES         = ['New','Active','High Priority','Paused','Closed'];
const PRIORITIES       = ['Low','Medium','High'];
const OWNERS           = ['Bruce','Susan'];

const sel = {
  background: 'var(--bg-card)', border: '1px solid var(--border)',
  borderRadius: 'var(--radius-sm)', color: 'var(--text)',
  padding: '5px 10px', fontSize: 12,
  fontFamily: 'DM Sans, sans-serif', cursor: 'pointer',
  outline: 'none', height: 32,
};

const activeSel = { ...sel, borderColor: 'var(--primary)', color: 'var(--primary)' };

export default function Filters({ filters, onChange, segments, pipeline }) {
  const set = (key, val) => onChange(prev => ({ ...prev, [key]: val }));
  const stages = pipeline === 'Investor' ? INVESTOR_STAGES : PARTNER_STAGES;
  const hasFilter = filters.status || filters.stage || filters.priority || filters.owner || filters.overdue || filters.search;

  return (
    <div className="filters-row" style={{ display: 'flex', gap: 8, marginBottom: 12, flexWrap: 'wrap', alignItems: 'center' }}>
      <input
        className="filter-search"
        type="text" placeholder="🔍  Search…" value={filters.search}
        onChange={e => set('search', e.target.value)}
        style={{ ...sel, padding: '5px 12px', flex: 1, minWidth: 180, maxWidth: 280 }}
      />

      <select className="filter-select" style={filters.stage ? activeSel : sel} value={filters.stage} onChange={e => set('stage', e.target.value)}>
        <option value="">All Stages</option>
        {stages.map(s => <option key={s}>{s}</option>)}
      </select>

      <select className="filter-select" style={filters.status ? activeSel : sel} value={filters.status} onChange={e => set('status', e.target.value)}>
        <option value="">All Statuses</option>
        {STATUSES.map(s => <option key={s}>{s}</option>)}
      </select>

      <select className="filter-select" style={filters.priority ? activeSel : sel} value={filters.priority} onChange={e => set('priority', e.target.value)}>
        <option value="">All Priorities</option>
        {PRIORITIES.map(p => <option key={p}>{p}</option>)}
      </select>

      <select className="filter-select" style={filters.owner ? activeSel : sel} value={filters.owner} onChange={e => set('owner', e.target.value)}>
        <option value="">All Owners</option>
        {OWNERS.map(o => <option key={o}>{o}</option>)}
      </select>

      {hasFilter && (
        <button
          className="filter-clear"
          onClick={() => onChange({ status:'', stage:'', priority:'', owner:'', overdue:false, search:'' })}
          style={{ background: 'transparent', border: 'none', color: 'var(--text-dim)', fontFamily: 'DM Sans, sans-serif', fontSize: 12, cursor: 'pointer', padding: '5px 8px', height: 32 }}
        >
          ✕ Clear
        </button>
      )}
    </div>
  );
}